<div *ngIf="tags?.length" class="chips-list tags-container">
  <div *ngFor="let tag of visibleTags; let i = index" class="chip-item chip-interactive" [matTooltip]="tag.title">
    <span class="chip-text">
      {{ tag.title }}
    </span>
  </div>

  <button
    *ngIf="hasMoreTags && !showAllTags"
    class="chip-item chip-more-button"
    type="button"
    [matTooltip]="'translations.global.ariaLabels.showMoreTags' | transloco: { count: hiddenTagsCount }"
    (click)="onShowMoreClick($event)"
  >
    <span class="chip-text"> ... </span>
  </button>
</div>
